import React, { Component } from 'react';
import classes from './Controls.css';
// import arrowBack from '../../img/arrowBackWhite.svg';
// import arrowForth from '../../img/arrowForthWhite.svg';
import Wrapper from '../../hoc/Wrapper/Wrapper';

// import uploadImg from '../../img/btns/1_upload.png';
// import chooseImg from '../../img/btns/2_choose.png';
// import addGiftImg from '../../img/btns/3_addgift.png';
// import fixImg from '../../img/btns/4_fix.png';
// import saveImg from '../../img/btns/5_save.png';
// import shareImg from '../../img/btns/6_share.png';
// import refreshImg from '../../img/btns/7_refresh.png';

import {
  // FacebookShareButton,
  VKShareButton,
  OKShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  ViberShareButton,
  // FacebookIcon,
  VKIcon,
  OKIcon,
  WhatsappIcon,
  TelegramIcon,
  ViberIcon,
} from 'react-share';

class Controls extends Component {
  render() {
    this.shareUrlWeb = 'https://zebra2023.karusel-tv.ru/?v=2';
    this.shareTitleWeb =
      'Создай свою праздничную открытку вместе с героями мультфильма «Зебра в клеточку»!';

    let controlsClasses = [classes.Controls, classes.Closed];
    if (this.props.open) {
      controlsClasses = [classes.Controls, classes.Open];
    }

    let isDesktopSize = window.innerWidth >= 769;

    // let giftClasses;

    // if (this.props.uploadedPhoto === true && this.props.photoEditing === false) {
    //   giftClasses = [classes.giftButton, classes.giftButtonEnabled].join(' ');
    // } else {
    //   giftClasses = [classes.giftButton, classes.giftButtonDisabled].join(' ');
    // }

    return (
      <Wrapper>
        {window.innerWidth < 769 && this.props.open && (
          <div className={classes.Backdrop} onClick={this.props.toggleControls}></div>
        )}
        <aside className={controlsClasses.join(' ')} onClick={this.props.onClick}>
          {(this.props.controlsStatus === 'step0' || true) && (
            <div className={[classes.controlsPart].join(' ')}>
              <div className={[classes.buttonHeader].join(' ')}>Выбрать открытку</div>
              <div className={classes.buttonGroup}>
                <button
                  className={[
                    classes.button,
                    classes.SwitchBtn,
                    classes.SwitchBtnLeft,
                  ].join(' ')}
                  onClick={this.props.choosePrevBackground}></button>
                <button
                  className={[
                    classes.button,
                    classes.SwitchBtn,
                    classes.SwitchBtnRight,
                  ].join(' ')}
                  onClick={this.props.chooseNextBackground}></button>
              </div>
            </div>
          )}
          {(this.props.controlsStatus === 'step1' || isDesktopSize || true) && (
            <div className={[classes.controlsPart].join(' ')}>
              <div className={[classes.buttonHeader].join(' ')}>Создать открытку</div>
              <div className={classes.buttonGroup}>
                <input
                  type="file"
                  id="loadAvatar"
                  className={classes.fileInput}
                  onChange={(e) => this.props.onFileInputChange(e)}
                />
                {/*<label*/}
                {/*  htmlFor="loadAvatar"*/}
                {/*  className={[classes.button, classes.button_inline].join(" ")}*/}
                {/*>*/}
                {/*  Загрузить фото*/}
                {/*</label>*/}

                <label
                  className={[classes.button, classes.buttonUpload].join(' ')}
                  htmlFor="loadAvatar">
                  Загрузить фото
                </label>
              </div>
              <div className={classes.buttonGroup}>
                {this.props.photoEditing ? (
                  <div
                    className={[classes.button].join(' ')}
                    onClick={this.props.stopChangingPhoto}>
                    Зафиксировать фото
                  </div>
                ) : (
                  <div
                    className={[classes.button, classes.buttonActive].join(' ')}
                    onClick={this.props.changePhoto}>
                    Разблокировать фото
                  </div>
                )}
              </div>
              {/* {!isDesktopSize && (
                <div
                  className={[
                    classes.button,
                    classes.buttonStep,
                    this.props.photoEditing ? classes.buttonDisabled : '',
                  ].join(' ')}
                  onClick={(e) =>
                    this.props.changeControlsStatus('step2', !this.props.photoEditing)
                  }>
                  Следующий шаг
                </div>
              )} */}
            </div>
          )}

          {(this.props.controlsStatus === 'step2' || isDesktopSize || true) && (
            <div className={[classes.controlsPart].join(' ')}>
              {/* <div className={classes.buttonHeaderImg}>
                <img src={addGiftImg} alt="" />
              </div> */}

              {/* <div className={[classes.buttonHeader].join(' ')}>Добавить элементы</div>

              <div className={[classes.giftsBlock].join(' ')}>
                {this.props.giftsList.map((gift) => {
                  return (
                    <span
                      key={gift.name}
                      id={gift.name}
                      className={giftClasses}
                      style={{
                        backgroundImage: `url(${gift.url})`,
                        backgroundSize: 'auto 80%',
                      }}
                      onClick={(e) => this.props.addGift(e, gift.name)}>
                      {gift.rusname}
                    </span>
                  );
                })}
              </div>  */}

              {/* <div
                className={[
                  classes.buttonGroup,
                  classes.colorButtons,
                  classes.buttonGroupColumn,
                ].join(' ')}>
                <div
                  className={[classes.buttonHeader, classes.giftButtonHeader].join(' ')}
                  onClick={this.props.toggleShowGiftPalette}
                  style={{ cursor: 'pointer' }}>
                  Выбрать
                </div>
                <button
                  className={[
                    classes.button,
                    classes.SwitchBtn,
                    classes.colorBtn,
                    classes.giftButton,
                  ].join(' ')}
                  onClick={this.props.toggleShowGiftPalette}
                  style={{ backgroundImage: `url(${arrowForth})` }}></button>
                {this.props.showGiftPalette && (
                  <div className={[classes.paletteBlock, classes.giftsBlock].join(' ')}>
                    {this.props.giftsList.map((gift) => {
                      return (
                        <span
                          key={gift.name}
                          id={gift.name}
                          style={{
                            backgroundImage: `url(${gift.url})`,
                            backgroundSize: 'auto 80%',
                          }}
                          onClick={(e) => this.props.addGift(e, gift.name)}>
                          {gift.rusname}
                        </span>
                      );
                    })}
                  </div>
                )}
              </div> */}
              {/* {!isDesktopSize && (
                <div
                  className={[classes.button, classes.buttonStep].join(' ')}
                  onClick={(e) => this.props.changeControlsStatus('step3', true)}>
                  Следующий шаг
                </div>
              )} */}
            </div>
          )}
          {(this.props.controlsStatus === 'step3' || isDesktopSize || true) && (
            <div className={[classes.controlsPart].join(' ')}>
              <div className={classes.buttonGroup}>
                <div
                  className={[
                    classes.button,
                    // classes.buttonHeaderImg,
                    // classes.buttonImg,
                    classes.buttonImgSave,
                    classes.buttonImgHover,
                  ].join(' ')}
                  onClick={this.props.onStageSave}>
                  {/* <img src={saveImg} alt="" /> */}
                  Сохранить открытку
                </div>
              </div>

              {/* <div className={classes.buttonHeaderImg}>
                <img src={shareImg} alt="" />
              </div> */}

              <div className={[classes.buttonHeader].join(' ')}>Поделиться</div>

              <div className={[classes.buttonGroup, classes.buttonGroupShare].join(' ')}>
                <VKShareButton
                  className={classes.buttonShare}
                  url={this.shareUrlWeb}
                  quote={this.shareTitleWeb}
                  onClick={this.props.shareOnClick}>
                  <VKIcon size={36} />
                </VKShareButton>
                <OKShareButton
                  className={classes.buttonShare}
                  url={this.shareUrlWeb}
                  quote={this.shareTitleWeb}
                  onClick={this.props.shareOnClick}>
                  <OKIcon size={36} />
                </OKShareButton>
                <WhatsappShareButton
                  className={classes.buttonShare}
                  url={this.shareUrlWeb}
                  quote={this.shareTitleWeb}
                  onClick={this.props.shareOnClick}>
                  <WhatsappIcon size={36} />
                </WhatsappShareButton>
                <ViberShareButton
                  className={classes.buttonShare}
                  url={this.shareUrlWeb}
                  quote={this.shareTitleWeb}
                  onClick={this.props.shareOnClick}>
                  <ViberIcon size={36} />
                </ViberShareButton>
                <TelegramShareButton
                  className={classes.buttonShare}
                  url={this.shareUrlWeb}
                  quote={this.shareTitleWeb}
                  onClick={this.props.shareOnClick}>
                  <TelegramIcon size={36} />
                </TelegramShareButton>
              </div>

              <a
                href="/"
                className={[
                  classes.button,
                  classes.buttonClear,
                  // classes.buttonHeaderImg,
                  // classes.buttonImg,
                  // classes.buttonImgClear,
                  // classes.buttonImgHover,
                ].join(' ')}>
                {/* <img src={refreshImg} alt="" /> */}
                Очистить
              </a>
            </div>
          )}
          {/*<div className={classes.buttonGroup}>*/}
          {/*  <button*/}
          {/*    className={[classes.button, classes.js_saveStage].join(" ")}*/}
          {/*    onClick={this.props.onStageSave}*/}
          {/*  >*/}
          {/*    Сохранить открытку*/}
          {/*  </button>*/}
          {/*</div>*/}
        </aside>
      </Wrapper>
    );
  }
}
export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls/Controls.js